
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
// import Docs from './docs';
// import "semantic-ui-css/semantic.min.css";

// ReactDOM.render(
//   document.getElementById('root'));


// Common Components Export
// export * from './commonComponents';
export * from './Common-Component';

serviceWorker.unregister();